import { render, staticRenderFns } from "./CardInfo.vue?vue&type=template&id=779b9369"
import script from "./CardInfo.vue?vue&type=script&lang=js"
export * from "./CardInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('779b9369')) {
      api.createRecord('779b9369', component.options)
    } else {
      api.reload('779b9369', component.options)
    }
    module.hot.accept("./CardInfo.vue?vue&type=template&id=779b9369", function () {
      api.rerender('779b9369', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Legajos/LegajoInfo/CardInfo.vue"
export default component.exports